import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  RESET_REGISTER_FLAG,
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESSFUL,
  VERIFY_EMAIL_FAILED,
  VERIFY_EMAIL_REQUEST_NEW_TOKEN,
  VERIFY_EMAIL_REQUEST_NEW_TOKEN_SUCCESSFUL,
  VERIFY_EMAIL_REQUEST_NEW_TOKEN_FAILED,
  CREATE_COMPANY,
  CREATE_COMPANY_SUCCESSFUL,
  CREATE_COMPANY_FAILED,
  VERIFY_USER_INVITATION,
  VERIFY_USER_INVITATION_SUCCESSFUL,
  VERIFY_USER_INVITATION_FAILED,
  ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT,
  ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_SUCCESSFUL,
  ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_FAILED,
  AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET,
  AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_SUCCESSFUL,
  AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_FAILED,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_FAILED,
} from "./actionTypes";

export const registerUser = (user) => {
  return {
    type: REGISTER_USER,
    payload: { user },
  };
};

export const registerUserSuccessful = (user) => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  };
};

export const registerUserFailed = (user) => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  };
};

export const resetRegisterFlag = () => {
  return {
    type: RESET_REGISTER_FLAG,
  };
};

// Verify Email
export const verifyEmail = (token) => {
  return {
    type: VERIFY_EMAIL,
    payload: token,
  };
};

export const verifyEmailSuccessful = (response) => {
  return {
    type: VERIFY_EMAIL_SUCCESSFUL,
    payload: response,
  };
};

export const verifyEmailFailed = (response) => {
  return {
    type: VERIFY_EMAIL_FAILED,
    payload: response,
  };
};

// request new verification token by sending email

export const sendNewVerificationEmail = (email) => {
  return {
    type: VERIFY_EMAIL_REQUEST_NEW_TOKEN,
    payload: email,
  };
};

export const sendNewVerificationEmailSuccessful = (response) => {
  return {
    type: VERIFY_EMAIL_REQUEST_NEW_TOKEN_SUCCESSFUL,
    payload: response,
  };
};

export const sendNewVerificationEmailFailed = (response) => {
  return {
    type: VERIFY_EMAIL_REQUEST_NEW_TOKEN_FAILED,
    payload: response,
  };
};

// Create Company

export const createCompany = (company) => {
  return {
    type: CREATE_COMPANY,
    payload: company,
  };
};

export const createCompanySuccessful = (company) => {
  return {
    type: CREATE_COMPANY_SUCCESSFUL,
    payload: company,
  };
};

export const createCompanyFailed = (company) => {
  return {
    type: CREATE_COMPANY_FAILED,
    payload: company,
  };
};

// verify user invitation to join a company
export const verifyUserInvitation = (token) => {
  return {
    type: VERIFY_USER_INVITATION,
    payload: token,
  };
};

export const verifyUserInvitationSuccessful = (response) => {
  return {
    type: VERIFY_USER_INVITATION_SUCCESSFUL,
    payload: response,
  };
};

export const verifyUserInvitationFailed = (response) => {
  return {
    type: VERIFY_USER_INVITATION_FAILED,
    payload: response,
  };
};

// Accept Invite and create new user account
export const acceptInviteCreateNewUserAccount = (user) => {
  return {
    type: ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT,
    payload: user,
  };
};

export const acceptInviteCreateNewUserAccountSuccessful = (response) => {
  return {
    type: ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_SUCCESSFUL,
    payload: response,
  };
};

export const acceptInviteCreateNewUserAccountFailed = (response) => {
  return {
    type: ACCEPT_INVITE_CREATE_NEW_USER_ACCOUNT_FAILED,
    payload: response,
  };
};

//AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET
export const authenticationRequestForEmailPasswordReset = (user) => {
  return {
    type: AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET,
    payload: user,
  };
};

export const authenticationRequestForEmailPasswordResetSuccessful = (
  response
) => {
  return {
    type: AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_SUCCESSFUL,
    payload: response,
  };
};

export const authenticationRequestForEmailPasswordResetFailed = (response) => {
  return {
    type: AUTHENTICATION_REQUEST_FOR_EMAIL_PASSWORD_RESET_FAILED,
    payload: response,
  };
};

//RESET_PASSWORD
export const resetPassword = (user) => {
  return {
    type: RESET_PASSWORD,
    payload: user,
  };
};

export const resetPasswordSuccessful = (response) => {
  return {
    type: RESET_PASSWORD_SUCCESSFUL,
    payload: response,
  };
};

export const resetPasswordFailed = (response) => {
  return {
    type: RESET_PASSWORD_FAILED,
    payload: response,
  };
};
